export default "__VITE_ASSET__DjyfFEXQ__"